import React, { useEffect, useState } from "react"

import {
    Row,
    Col,
    Card,
    CardBody,
    FormGroup,
    Label,
    Input,
    Container,
    FormFeedback,
    Form,
} from "reactstrap"
// Formik validation
import { useFormik } from "formik"

//Import Breadcrumb
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import { useHistory, useParams } from "react-router-dom"
import ResultHandler from "../../../../components/ResultHandler"
import { editInvoiceable, getInvoiceable } from "../../../../api/invoiceables"
import FormButtonHandler from "../../../../components/FormButtonHandler"
import { useResponse } from "../../../../hooks/useResponse"
import { useTranslation } from "react-i18next"
import { useGetInstence } from "../../../../hooks/useGetInstence"

import FIELDS from "./CONSTANT"
import InvoiceableForm from "./InvoiceableForm"
import * as Yup from "yup"


const TYPES = {
    'select': null,
    'add-more': [],
    'checkbox': false
}

const initialValues = {}
const FIELDS_VALIDATION = {}

FIELDS.forEach(f => {
    initialValues[f.key] = TYPES[f.type] ? TYPES[f.type] : "" 
    if(f.type == 'file'){
        FIELDS_VALIDATION[f.key+"_preview"] = Yup.string().required("This Field Is Required")

    }else{
        FIELDS_VALIDATION[f.key] = Yup.string().required("This Field Is Required")
    }
})


const EditInvoiceable = () => {
    let navigate = useHistory()

    const { t } = useTranslation()

    const params = useParams()

    const [editedInvoiceable, setEditedInvoiceable] = useState(null)

    const { instenceLoading, instenceError, instenceSuccess } = useGetInstence(
        getInvoiceable,
        params.id,
        response => {
            setEditedInvoiceable(response.data.data.invoiceable)
        }
    )


    const { setData, loading, error, success } = useResponse(editInvoiceable, () => {
        navigate.goBack()
    })

    // Form validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            ...editedInvoiceable,
        },
        validationSchema: Yup.object(FIELDS_VALIDATION),
        onSubmit: values => {
            let data = {
                ...values
            }
            setData({ type: "edit", id: params.id, data })
        },
    })



    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs
                        title={t("Invoiceables")}
                        breadcrumbItem={"Edit Invoiceable"}
                    />
                    
                        {editedInvoiceable && (
                            <Form
                                className="needs-validation"
                                onSubmit={e => {
                                    e.preventDefault()
                                    validation.handleSubmit()
                                    return false
                                }}
                            >
                                <InvoiceableForm validation={validation} />

                                <FormButtonHandler btnTxt="Edit" loading={loading} />
                            </Form>
                        )}

                        <ResultHandler
                            loading={instenceLoading}
                            error={error}
                            success={success}
                            successMsg={"Updated Successfully!"}
                        />
                                
                </Container>
            </div>
        </React.Fragment>
    )
}

export default EditInvoiceable